import { FC } from "react";
import {
  Avatar,
  Box,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MenuIcon from "@mui/icons-material/Menu";

import { selectMe } from "../../../entities/me";
import { useAppSelector } from "../../../app/store";
import { tokens } from "../../../shared/config/theme";

interface AdminHeaderProps {
  title: string;
  collapsed: boolean;
  onToggleCollapsed: () => void;
  onLogout: () => void;
}

export const AdminHeader: FC<AdminHeaderProps> = ({
  title,
  collapsed,
  onToggleCollapsed,
  onLogout,
}) => {
  const me = useAppSelector(selectMe);
  const fullName = [me?.firstName, me?.lastName].filter(Boolean).join(" ");

  return (
    <Box
      component="header"
      sx={{
        height: tokens.header.height,
        minHeight: tokens.header.height,
        px: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        borderBottom: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
        <IconButton
          onClick={onToggleCollapsed}
          aria-label={collapsed ? "Развернуть меню" : "Свернуть меню"}
        >
          {collapsed ? <MenuIcon /> : <ChevronLeftIcon />}
        </IconButton>
        <Typography
          variant="h5"
          noWrap
          sx={{ fontWeight: 600 }}
        >
          {title}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            minWidth: 0,
          }}
        >
          <Avatar
            src={me?.avatarUrl || undefined}
            alt={fullName || "Администратор"}
            sx={{ width: 36, height: 36 }}
          />
          <Box sx={{ display: { xs: "none", md: "block" }, minWidth: 0 }}>
            <Typography noWrap fontWeight={600} fontSize={13} lineHeight={1.3}>
              {fullName || "Администратор"}
            </Typography>
            {me?.email && (
              <Typography
                noWrap
                color="text.secondary"
                fontSize={12}
                lineHeight={1.3}
              >
                {me.email}
              </Typography>
            )}
          </Box>
        </Box>
        <Tooltip title="Выйти">
          <IconButton onClick={onLogout} aria-label="Выйти">
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
